import React from 'react';

const EmptyState = ({ onCreate }) => {
    return (
        <div className="empty-state">
            <div className="empty-icon">📋</div>
            <h2>No Business Profiles Yet</h2>
            <p>Create your first business profile to personalize your WordPress themes</p>
            <button className="btn-primary" onClick={onCreate}>
                Create Your First Profile
            </button>
        </div>
    );
};

export default EmptyState;
